{
  "author": "NAME",
  "chair": "NAME",
  "collection-editor": "NAME",
  "compiler": "NAME",
  "composer": "NAME",
  "container-author": "NAME",
  "contributor": "NAME",
  "curator": "NAME",
  "director": "NAME",
  "editor": "NAME",
  "editorial-director": "NAME",
  "editor-translator": "NAME",
  "executive-producer": "NAME",
  "guest": "NAME",
  "host": "NAME",
  "illustrator": "NAME",
  "interviewer": "NAME",
  "narrator": "NAME",
  "organizer": "NAME",
  "original-author": "NAME",
  "performer": "NAME",
  "producer": "NAME",
  "recipient": "NAME",
  "reviewed-author": "NAME",
  "script-writer": "NAME",
  "series-creator": "NAME",
  "translator": "NAME",

  "accessed": "DATE",
  "available-date": "DATE",
  "event-date": "DATE",
  "issued": "DATE_YEAR",
  "original-date": "DATE",
  "submitted": "DATE",

  "id": "ID",
  "ISSN,ISBN": "ISBN",
  "keyword": "KEYWORD",
  "page": "PAGE",
  "type": "TYPE",
  "DOI": "DOI"
}
